/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconAmex from '@telus-uds/palette-allium/build/rn/icons/Amex'
import PaletteIconTimes from '@telus-uds/palette-allium/build/rn/icons/Times'
import PaletteIconCreditCard from '@telus-uds/palette-allium/build/rn/icons/CreditCard'
import PaletteIconMasterCard from '@telus-uds/palette-allium/build/rn/icons/MasterCard'
import PaletteIconInvisible from '@telus-uds/palette-allium/build/rn/icons/Invisible'
import PaletteIconVisible from '@telus-uds/palette-allium/build/rn/icons/Visible'
import PaletteIconVisa from '@telus-uds/palette-allium/build/rn/icons/Visa'
import PaletteIconStatusSuccess from '@telus-uds/palette-allium/build/rn/icons/StatusSuccess'
import PaletteIconStatusError from '@telus-uds/palette-allium/build/rn/icons/StatusError'
const theme = {
  appearances: {
    focus: {
      description: 'Focus states for some input elements are well supported across web, RN, ios and android',
      type: 'state',
      values: [ true ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    numeric: {
      description: 'capability to only allow numbers',
      type: 'variant',
      values: [ true ]
    },
    password: {
      description: 'capability that helps masking and unmasking text',
      type: 'variant',
      values: [ true ]
    },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning', 'feature' ]
    }
  },
  rules: [
    {
      if: { hover: true, inactive: null },
      tokens: { outerBackgroundColor: '#e3e6e8', outerBorderColor: '#e3e6e8' }
    },
    {
      if: { validation: 'success' },
      tokens: {
        borderColor: '#2b8000',
        icon: PaletteIconStatusSuccess,
        iconColor: '#2b8000'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        borderColor: '#e12339',
        icon: PaletteIconStatusError,
        iconColor: '#e12339'
      }
    },
    {
      if: { focus: true },
      tokens: { borderColor: '#7c53a5', borderWidth: 3, icon: null }
    },
    {
      if: { inactive: true },
      tokens: { backgroundColor: '#f4f4f7', borderColor: '#f4f4f7' }
    }
  ],
  tokens: {
    amexIcon: PaletteIconAmex,
    backgroundColor: '#ffffff',
    borderColor: '#676e73',
    borderRadius: 4,
    borderWidth: 1,
    buttonSize: 32,
    buttonsGap: 1,
    buttonsPaddingRight: 8,
    clearButtonIcon: PaletteIconTimes,
    color: '#414547',
    defaultCreditIcon: PaletteIconCreditCard,
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    icon: null,
    iconColor: 'rgba(0, 0, 0, 0)',
    iconLeftGap: 8,
    iconLeftPaddingBottom: 14,
    iconSize: 24,
    leftIconPaddingBottom: 8,
    lineHeight: 1.5,
    masterCardIcon: PaletteIconMasterCard,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderWidth: 2,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    passwordHideButtonIcon: PaletteIconInvisible,
    passwordShowButtonIcon: PaletteIconVisible,
    visaIcon: PaletteIconVisa
  }
}
export default theme
